import { render, staticRenderFns } from "./CustomerEditNote.vue?vue&type=template&id=375cbf82&scoped=true&"
import script from "./CustomerEditNote.vue?vue&type=script&lang=ts&"
export * from "./CustomerEditNote.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerEditNote.vue?vue&type=style&index=0&id=375cbf82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375cbf82",
  null
  
)

export default component.exports